export enum LocalizedStringOptions {
  NL = 'nl',
  EN = 'en',
}

export type LocalizedString = Record<LocalizedStringOptions, string>;

export const fallbackLanguage = LocalizedStringOptions.EN;
